// ConfirmPopup (primevue 3.53) при открытии заменяет переданный target на
// document.activeElement и выравнивается по нему. Если кнопка по клику не получила
// фокус (Safari, часть браузеров на Linux), активным остаётся body - и окно
// подтверждения появляется в левом верхнем углу экрана.
// Перед показом ставим фокус на target - один раз для всех вызовов confirm.require.

export function InitConfirmPopupTarget(app) {
  const service = app.config.globalProperties.$confirm;
  if (!service?.require) return;

  const require = service.require;
  service.require = (options) => {
    const target = options?.target;
    if (target instanceof HTMLElement && document.activeElement !== target) {
      target.focus({ preventScroll: true });
    }
    return require(options);
  };
}
